var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgArrowGoBack5 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11V7H13C14.5913 7 16.1174 7.63214 17.2426 8.75736C18.3679 9.88258 19 11.4087 19 13C19 14.5913 18.3679 16.1174 17.2426 17.2426C16.1174 18.3679 14.5913 19 13 19H12V21H13C15.1217 21 17.1566 20.1571 18.6569 18.6569C20.1571 17.1566 21 15.1217 21 13C21 10.8783 20.1571 8.84344 18.6569 7.34315C17.1566 5.84285 15.1217 5 13 5H8V1L2 6L8 11ZM3.48722 21.7997C3.93608 22.0128 4.4446 22.1193 5.01278 22.1193C5.62926 22.1193 6.17188 21.9915 6.64062 21.7358C7.11222 21.4773 7.48011 21.1236 7.74432 20.6747C8.01136 20.223 8.14489 19.7088 8.14489 19.1321C8.14489 18.5725 8.02557 18.0753 7.78693 17.6406C7.5483 17.206 7.22159 16.8651 6.80682 16.6179C6.39205 16.3679 5.92045 16.2429 5.39205 16.2429C5.03977 16.2429 4.71591 16.3068 4.42045 16.4347C4.125 16.5597 3.89631 16.7173 3.73438 16.9077H3.68324L3.93466 14.5938H7.68892V13.2727H2.62642L2.17045 17.7727L3.59801 18.0071C3.74574 17.8452 3.94602 17.7145 4.19886 17.6151C4.4517 17.5156 4.70881 17.4673 4.97017 17.4702C5.29119 17.4702 5.57528 17.544 5.82244 17.6918C6.0696 17.8367 6.2642 18.0369 6.40625 18.2926C6.5483 18.5483 6.6179 18.8409 6.61506 19.1705C6.6179 19.4943 6.54972 19.7827 6.41051 20.0355C6.27131 20.2884 6.08097 20.4858 5.83949 20.6278C5.59801 20.7699 5.32244 20.8409 5.01278 20.8409C4.6179 20.8409 4.27983 20.7287 3.99858 20.5043C3.71733 20.277 3.5625 19.9844 3.53409 19.6264H2C2.01705 20.1094 2.15625 20.5384 2.41761 20.9134C2.68182 21.2884 3.03835 21.5838 3.48722 21.7997Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowGoBack5);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-go-back-5.0d1ca790cc257025c4b012855f7ad1fa.svg";